/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { ProgramacionActividad } from '../model/programacionActividad';
import { ProgramacionActividadBase } from '../model/programacionActividadBase';
import { ProgramacionActividadPatch } from '../model/programacionActividadPatch';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ProgramacionActividadService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * Obtiene el listing de personas.
     * Permite descargar el listin de personas.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param yyyymmdd La fecha de la programacion.
     * @param attachment Especifica el disposition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdActividadesByIdListing(empresaId: string, actividadId: string, yyyymmdd: string, attachment?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getEmpresasByIdActividadesByIdListing(empresaId: string, actividadId: string, yyyymmdd: string, attachment?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getEmpresasByIdActividadesByIdListing(empresaId: string, actividadId: string, yyyymmdd: string, attachment?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getEmpresasByIdActividadesByIdListing(empresaId: string, actividadId: string, yyyymmdd: string, attachment?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdActividadesByIdListing.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresasByIdActividadesByIdListing.');
        }
        if (yyyymmdd === null || yyyymmdd === undefined) {
            throw new Error('Required parameter yyyymmdd was null or undefined when calling getEmpresasByIdActividadesByIdListing.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (attachment !== undefined && attachment !== null) {
            queryParameters = queryParameters.set('attachment', <any>attachment);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/${encodeURIComponent(String(yyyymmdd))}/listing`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de programaciones paginadas. por defecto se ordena en orden descendente de fecha.
     * La programacion es mostradacon su paginacion.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param period 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, period?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProgramacionActividad>>;
    public getEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, period?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProgramacionActividad>>>;
    public getEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, period?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProgramacionActividad>>>;
    public getEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, period?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdActividadesByIdProgramaciones.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresasByIdActividadesByIdProgramaciones.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if (period !== undefined && period !== null) {
            queryParameters = queryParameters.set('period', <any>period);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<ProgramacionActividad>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Establece una programacion para el dia especifico
     * Establece una nueva programacion para el dia especifico.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param yyyymmdd La fecha de la programacion.
     * @param programacionActividadPatch Un Objeto JSON que representa la informaciÃ³n de la programacion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadPatch?: ProgramacionActividadPatch, observe?: 'body', reportProgress?: boolean): Observable<ProgramacionActividadPatch>;
    public patchEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadPatch?: ProgramacionActividadPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProgramacionActividadPatch>>;
    public patchEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadPatch?: ProgramacionActividadPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProgramacionActividadPatch>>;
    public patchEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadPatch?: ProgramacionActividadPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling patchEmpresasByIdActividadesByIdProgramacionesDate.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling patchEmpresasByIdActividadesByIdProgramacionesDate.');
        }
        if (yyyymmdd === null || yyyymmdd === undefined) {
            throw new Error('Required parameter yyyymmdd was null or undefined when calling patchEmpresasByIdActividadesByIdProgramacionesDate.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<ProgramacionActividadPatch>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/${encodeURIComponent(String(yyyymmdd))}`,
            programacionActividadPatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva programacion para la actividad especificada.
     * Crea una nueva programacion para la actividad especificada.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param programacionActividadBase Un Objeto JSON que representa la informacion de la programacion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'body', reportProgress?: boolean): Observable<ProgramacionActividad>;
    public postEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProgramacionActividad>>;
    public postEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProgramacionActividad>>;
    public postEmpresasByIdActividadesByIdProgramaciones(empresaId: string, actividadId: string, programacionActividadBase?: ProgramacionActividadBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdActividadesByIdProgramaciones.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling postEmpresasByIdActividadesByIdProgramaciones.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ProgramacionActividad>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/`,
            programacionActividadBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Establece una programacion para el dia especifico
     * Establece una nueva programacion para el dia especifico.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param yyyymmdd La fecha de la programacion.
     * @param programacionActividadBase Un Objeto JSON que representa la informaciÃ³n de la programacion.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'body', reportProgress?: boolean): Observable<ProgramacionActividad>;
    public putEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProgramacionActividad>>;
    public putEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadBase?: ProgramacionActividadBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProgramacionActividad>>;
    public putEmpresasByIdActividadesByIdProgramacionesDate(empresaId: string, actividadId: string, yyyymmdd: string, programacionActividadBase?: ProgramacionActividadBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling putEmpresasByIdActividadesByIdProgramacionesDate.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling putEmpresasByIdActividadesByIdProgramacionesDate.');
        }
        if (yyyymmdd === null || yyyymmdd === undefined) {
            throw new Error('Required parameter yyyymmdd was null or undefined when calling putEmpresasByIdActividadesByIdProgramacionesDate.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ProgramacionActividad>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/${encodeURIComponent(String(yyyymmdd))}`,
            programacionActividadBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
